// Currency enum mapping from Ruby ForeignExchangeRateConcern::Enums
export const CURRENCY_ENUM = [
  "EUR",
  "USD",
  "AUD",
  "JPY",
  "GBP",
  "HKD",
  "SGD",
  "CHF",
  "PLN",
  "RUB",
  "BRL",
  "HUF",
  "CZK",
  "KRW",
  "SEK",
  "VND",
  "CNH",
  "CNY",
  "DKK",
  "NOK",
  "CAD",
  "MXN",
  "GBX",
  "BGN",
  "RON",
  "ISK",
  "HRK",
  "TRY",
  "IDR",
  "ILS",
  "INR",
  "MYR",
  "NZD",
  "PHP",
  "THB",
  "ZAR",
  "AED",
];

export const getCurrencyCode = (index: number): string => {
  return CURRENCY_ENUM[index] || `Unknown(${index})`;
};

export const createForeignExchangeCurrencyOptions = () => {
  return CURRENCY_ENUM.map((currency, index) => ({
    value: index.toString(),
    label: currency,
  }));
};
